import React from 'react';
import Parse from 'url-parse';
import Svgs from '../../resources/svgs';
import './social.scss';


const Social = () => {
    React.useEffect(() => {
      const socialElems = document.querySelectorAll('.esri-social-sharing');
      if (socialElems.length > 0 && window.ESRI_SOCIAL) {
        socialElems.forEach((socialElem) => {
          window.ESRI_SOCIAL.loadSocialMediaIcons(socialElem, 'dynamic');
        });

      }
    });
    const targetUrl = Parse(window.location.href);
    // console.log(targetUrl.query.split('?targetUrl'));

return typeof window.oneForm === 'undefined'
  ? <div
  className = "ieSocial btn"
  onClick={() => {
    // window.open(`mailTo:?body=${targetUrl || window.location.href}`);
   }}
  >
    <span
    className = "ieSocial-text"
    >Share</span>{Svgs.email}
  </div>
  : <div
    className="page-social esri-social-sharing tapestry-header-social"
    data-social-sites="linkedin,facebook,twitter,email"
  >
    {/* <span className="icon-social-linkedin" aria-label="linkedin" data-event="track-component" data-component-name="social" data-component-link="linkedin" data-component-link-placement="1" data-component-link-type="image"></span><span className="icon-social-facebook" aria-label="facebook" data-event="track-component" data-component-name="social" data-component-link="facebook" data-component-link-placement="2" data-component-link-type="image"></span><span className="icon-social-twitter" aria-label="twitter" data-event="track-component" data-component-name="social" data-component-link="twitter" data-component-link-placement="3" data-component-link-type="image"></span><span className="icon-social-contact" aria-label="email" data-event="track-component" data-component-name="social" data-component-link="email" data-component-link-placement="4" data-component-link-type="image"></span> */}
  </div>;
}
;
export default Social;
